// extracted by mini-css-extract-plugin
export default {"container":"AssetsTable_container__jeg6M","header":"AssetsTable_header__BMpcb","table":"AssetsTable_table__OOuc2"};